import { createActionType, createAsyncAction } from "./create-actions";
export const RESET_PASSWORD = createActionType("RESET_PASSWORD");

export const resetPassword = (data: any) =>
  createAsyncAction(RESET_PASSWORD, "/auth/request-reset", "post", data);
